// Downscale + convert an image to JPEG in the browser so large phone photos upload reliably.
export function compressImage(file) {
  return new Promise((resolve) => {
    if (!file.type || !file.type.startsWith("image/") || file.type === "image/gif") {
      return resolve(file);
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      const maxDim = 1400;
      if (width > maxDim || height > maxDim) {
        const s = maxDim / Math.max(width, height);
        width = Math.round(width * s);
        height = Math.round(height * s);
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (!blob) return resolve(file);
          const name = (file.name.replace(/\.[^.]+$/, "") || "avatar") + ".jpg";
          resolve(new File([blob], name, { type: "image/jpeg" }));
        },
        "image/jpeg",
        0.85,
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });
}
